import axios from "axios";
import store from "@/store";
const moment = require("moment");

export default async function weather(startDate, endDate, cityName, { lowPriority = true } = {}) {
  try {
    const baseUrl = "https://fida.flow-insight.com/api/getWeatherData";
    const dateFormat = "YYYY-MM-DD";
    const start = startDate.format(dateFormat);
    const end = endDate.format(dateFormat);

    const cities = [...new Set(cityName.map(c => c.cityId))];
    const isHourly = start === end;

    const token = store.state.user.sessionClient.access_token;

    const getApiWeather = async (forceDaily = false) => {
      const response = await axios.post(
        baseUrl,
        {
          frequency: forceDaily ? "daily" : isHourly ? "hourly" : "daily",
          startDate: start,
          endDate: end,
          cities,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      return response?.response.data; // ✅ fixed typo (response.response.data)
    };

    let weather;
    if (lowPriority) {
      // defer execution when browser is idle
      weather = await new Promise((resolve, reject) => {
        requestIdleCallback(async () => {
          try {
            resolve(await getApiWeather());
          } catch (e) {
            reject(e);
          }
        });
      });
    } else {
      weather = await getApiWeather();
    }

    // optional: fetch daily as fallback
    let w = {};
    if (isHourly && window.location.pathname === "/detailed-report") {
      w = await getApiWeather(true);
    }

    // ... same processing as before
    const weatherObj = {};
    let dataHourly = [];

    for (const key in weather) {
      if (!weather.hasOwnProperty(key)) continue;

      const tempObj = { temp: 0, tempMin: 0, tempMax: 0 };
      const iconCounts = {};
      const descriptionCounts = {};
      const hourly = {};

      for (const city in weather[key]) {
        const obj = weather[key][city];

        if (isHourly) {
          for (const hr in obj) {
            const prev = hourly[hr] || { temp: 0, tempMax: 0, tempMin: 0 };
            hourly[hr] = {
              temp: obj[hr].temp + prev.temp,
              tempMax: obj[hr].tempMax + prev.tempMax,
              tempMin: obj[hr].tempMin + prev.tempMin,
            };
            iconCounts[obj[hr].icon] = (iconCounts[obj[hr].icon] || 0) + 1;
            descriptionCounts[obj[hr].description] =
              (descriptionCounts[obj[hr].description] || 0) + 1;
          }
        } else {
          tempObj.temp += obj.temp;
          tempObj.tempMax += obj.tempMax;
          tempObj.tempMin += obj.tempMin;
          iconCounts[obj.icon] = (iconCounts[obj.icon] || 0) + 1;
          descriptionCounts[obj.description] =
            (descriptionCounts[obj.description] || 0) + 1;
        }
      }

      const mostCommonIcon =
        Object.keys(iconCounts).length > 0
          ? Object.keys(iconCounts).reduce((a, b) =>
              iconCounts[a] > iconCounts[b] ? a : b
            )
          : null;

      const mostCommonDescription =
        Object.keys(descriptionCounts).length > 0
          ? Object.keys(descriptionCounts).reduce((a, b) =>
              descriptionCounts[a] > descriptionCounts[b] ? a : b
            )
          : null;

      const divider = Object.keys(weather[key] || {}).length || 1;
      const dateKey = moment(key).format(dateFormat);

      const average = {
        temp: tempObj.temp / divider,
        tempMax: tempObj.tempMax / divider,
        tempMin: tempObj.tempMin / divider,
        icon: mostCommonIcon,
        description: mostCommonDescription,
      };

      for (const hour in hourly) {
        hourly[hour].temp /= divider;
        hourly[hour].tempMax /= divider;
        hourly[hour].tempMin /= divider;
        hourly[hour].icon = mostCommonIcon;
        hourly[hour].description = mostCommonDescription;
      }

      weatherObj[dateKey] = average;
      if (isHourly) dataHourly.push(hourly);
    }

    return {
      weather: isHourly ? dataHourly : [weatherObj],
      weatherApi: isHourly ? w : weather,
    };
  } catch (error) {
    console.error("Weather API error:", error.message);
    return { weather: [], weatherApi: {}, cities: [] };
  }
}
